import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery
} from '@mui/material'
import { CheckmarkCircle, Icon } from 'components'
import { theme } from 'config'
import { inject, observer } from 'mobx-react'
import { Course } from 'models'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import {  Pages, RoutingParams } from 'routes'
import { RoutingStore } from 'stores'
import styled from 'styled-components'


export interface ICourseSidebarProps {
  course:        Course,
  routingStore?: RoutingStore,
}

/**
 * Displays course controls and progress when a user is taking a course
 *
 * @type Participant, Manager
 */
export const CourseSidebar = inject('routingStore')(observer((props: ICourseSidebarProps) => {
  const { t }                     = useTranslation();
  const { course, routingStore }  = props;
  const isNotMobileView           = useMediaQuery(theme.breakpoints.up('sm'));
  const params: RoutingParams     = useParams<RoutingParams>();

  let stepCount: number = 0, chapCount: number = 0;
  return (
    <>
      <Box display='flex' flexDirection='column' alignItems='left' mt={isNotMobileView ? 4 : 0}>
        <ListItem>
          <ListItemButton
            onClick = {() => routingStore.push(Pages.Library)}
            sx      = {{ borderRadius: '6px' }}
          >
            <ListItemIcon>
              <Icon iconId='arrow-left' size='size-24' />
            </ListItemIcon>
            <ListItemText primary={t('back_to_library')} />
          </ListItemButton>
        </ListItem>
        <List
          sx={{
            width:          '100%',
            flexDirection:  'column',
            justifyContent: 'center',
            display:        'flex',
          }}
        >
          {course?.steps.filter(s => !s.isSub).map((s) => {
            if (s.isChapter) {
              stepCount = 0;
              chapCount++;
            } else stepCount++;

            if(s.getParent && !s.getParent.isChapter) return null;

            return (
              <ListItem
                key = {s.id}
                sx  = {{
                  padding: '0px 16px'
                }}
              >
                <ListItemButton
                  selected = {
                    s.id === course.getCurStep?.id || 
                    (
                      course.getCurStep?.getParent && 
                      course.getCurStep?.getParent.isGrid && 
                      course.getCurStep?.getParent.id === s.id
                    )
                  }
                  key      = {s.id}
                  disabled = {!s.isAccessible}
                  sx       = {{
                    color:        s?.isAccessible ? 'Menu': '#D9D9D9',
                    pl:           !s?.isChapter ? 4:        3,
                    borderRadius: '6px'
                  }}
                  onClick = {() => {
                    course.setCurStep(s)
                    if (params.view)
                      routingStore.push(Pages.Course, {id: '' + course.id});
                  }}
                >
                  <Box>
                    <CheckmarkCircle 
                      variant  = {s.isCompleted ? 'success' : 'unchecked'}
                      inverted = {true}
                      boxProps = {{
                        marginRight: "1rem"
                      }}
                    />
                  </Box>
                  <Typography
                    sx         = {{ color: s?.isAccessible ? 'Menu' : '#D9D9D9' }}
                    fontSize   = {!s.isChapter && theme.typography.fontSize}
                    fontWeight = {
                      s.isChapter
                        ? theme.typography.fontWeightBold
                        : theme.typography.fontWeightRegular
                    }
                  >
                    {s.name}
                  </Typography>
                </ListItemButton>
              </ListItem>
            )
          }).filter(Boolean)}
        </List>
      </Box>
    </>
  );
}));